@if (isLoginRoute()) {
<router-outlet></router-outlet>
} @else {

<app-navbar></app-navbar>

<div class="shell" [class.sidebar-open]="sidebar.open()" [class.sidebar-closed]="!sidebar.open()"
  [class.sidebar-collapsed]="sidebar.collapsed()">

  @if (sidebar.open()) {
  <div class="sidebar-backdrop" (click)="sidebar.closeOnMobile()"></div>
  }

  <aside class="sidebar-wrap">
    <app-sidebar></app-sidebar>
  </aside>

  <main class="content">
    <router-outlet></router-outlet>
  </main>

</div>
}